@if (isOffline) {
    <app-error-page-layout
        icon="wifi_off"
        iconBgClass="bg-yellow-100"
        iconColorClass="text-yellow-600"
        [title]="'offline.title' | translate"
        [description]="'offline.description' | translate"
        [hint]="'offline.hint' | translate"
        [fullScreen]="true"
    >
        <ng-container actions>
            <button
                mat-flat-button
                color="primary"
                class="px-8 py-3 text-base"
                (click)="retry()"
            >
                <mat-icon class="mr-2">refresh</mat-icon>
                {{ 'offline.retry' | translate }}
            </button>
        </ng-container>
    </app-error-page-layout>
}
